<template>
    <div style="background: #FAFAFA;">
        <div class="container" style="padding-bottom: 40px; padding-top: 0.5rem">

            <div class="top-spot mt-5">
                <h5 @click="goBack()"><span><i class="fa fa-chevron-left"></i></span>Your Submission</h5>
            </div>

            <div class="display-body">
                <div class="row justify-content-center">
                    <div class="col-md-4">
                       <div class="chalenge-item">
                            <div class="kid-name-profile">
                                <img v-if="kidDetails.avatar_url != null" :src="kidDetails.avatar_url" alt="pix" style="width: 38px; height: 38px; border: 1px solid #e2e3e3;">
                                <img v-else src="../../assets/icons/profile-icon.svg" alt="pix">
                                <div>
                                    <h5>{{kidDetails.firstname}} {{ kidDetails.lastname }}</h5>
                                    <p>#{{submissionData.data.challenge_category.name.replace(/\s+/g, '')}}</p>
                                </div>
                            </div>

                            <div class="challenge-body">
                                <!-- <h3>Wole Soyinka</h3> -->
                                <h4>{{ submissionData.data.title }}</h4>
                                <h6>#{{submissionData.data.challenge_category.name.replace(/\s+/g, '')}}</h6>

                                <div>
                                    <img v-if="getPriorityMedia(submissionData.submission.media).url && getPriorityMedia(submissionData.submission.media).media_type === 'image'"  class="w-100" :src="getPriorityMedia(submissionData.submission.media).url" alt="media">
                                    <!-- Display Image if type is image -->
                                    <!-- <img v-if="item.media.media_type === 'image'" :src="item.media.url" alt="Gallery Image" class="w-100" /> -->

                                    <!-- Display Video if type is video -->
                                    
                                    <video v-else-if="getPriorityMedia(submissionData.submission.media).media_type === 'video'" 
                                        :src="getPriorityMedia(submissionData.submission.media).url" controls>
                                    Your browser does not support the video tag.
                                    </video>
                                    
                                </div>
                                <p v-if="(submissionData.submission.media).length > 1 " class="view-more" data-toggle="modal" data-target="#mediaView" @click="modalMedia = submissionData.submission.media;">view more...</p>

                                <!-- <div>
                                    <img class="w-100" src="https://res.cloudinary.com/dr2wljdlc/image/upload/v1772108831/artwork_pdu1q6.svg" alt="media">
                                    
                                </div> -->
                                <h5 class="vote-ends">Voting ends: {{ submissionData.data.voting_end_date_and_time | moment }}</h5>

                                <div class="form-group vote-btn">
                                    <button class="btn vote-now mb-2" @click="copyLink()">Copy Link</button>
                                    <!-- <button class="btn copy-now" @click="copyLink()">Copy link</button> -->
                                </div>
                            </div>

                            <div class="modal fade" id="mediaView" tabindex="-1" aria-labelledby="mediaView" aria-hidden="true">
                                <div class="modal-dialog modal-dialog-centered">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title title-modal" id="media-view">More Media</h5>
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div class="modal-body more-media">
                                            <div v-for="(more, index) in modalMedia" :key="index" class="">
                                                
                                                <img v-if="more.url && more.media_type === 'image'"  class="w-100 mb-3" :src="more.url" alt="media">
                                                
                                                <!-- Display Image if type is image -->
                                                <!-- <img v-if="item.media.media_type === 'image'" :src="item.media.url" alt="Gallery Image" class="w-100" /> -->

                                                <!-- Display Video if type is video -->
                                                
                                                
                                                <video class="mb-3" v-if="more.media_type === 'video'" 
                                                    :src="more.url" controls style="width: 100%;">
                                                    Your browser does not support the video tag.
                                                </video>
                                                
                                                
                                            </div>
                                        </div>
                                
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                            <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                       </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>



<script>
import { Service } from "../../store/service";
const Api = new Service();
import PageLoader from "../../components/PageLoader.vue";
import moment from "moment";
import $ from "jquery";
export default {
    name: "Submission",
    components: {
        PageLoader
    },

    data() {
        return {
            submissionData: null,
            kidDetails: null,
            modalMedia: '',

        };
    },

    computed: {
        baseUrl() {
            // this.baseUrl = window.location.hostname === 'localhost' || window.location.hostname === '172.20.10.3';
            
            // return this.baseUrl 
            // ? 'http://localhost:8080/'          // Your local backend port
            // : 'https://myshelta.com/'; // Your production backend URL

            const hostname = window.location.hostname;

            // 2. Return the matching API endpoint based on the domain
            switch (hostname) {
                case 'localhost':
                case '127.0.0.1':
                    return `http://localhost:8080/shared-challenge/${this.submissionData.data.id}/${this.kidDetails.id}`; // Your local backend port ${this.postings.id}/${this.kidDetails.id}

                case 'testfront.myshelta.com':
                return `testfront.myshelta.com/${this.submissionData.data.id}/${this.kidDetails.id}`; // Your staging/testing API

                case 'myshelta.com':
                    return `myshelta.com/${this.submissionData.data.id}/${this.kidDetails.id}`; // Your live production API

                default:
                // Fallback in case you access via an IP address or subdomain (e.g., www.)
                return `myshelta.com`; 
            }
        }
    },

    created() {
        // Retrieve data from storage
        const saved = localStorage.getItem('kidSubmission');
        const kidItem = localStorage.getItem('kidDetails');
        if (saved) {
            this.submissionData = JSON.parse(saved);
            this.kidDetails = JSON.parse(kidItem);
            console.log("Data fetched:", this.submissionData);
        }
        else {
            this.$router.go(-1);
        }
    },
    // beforeDestroy() {
    //     // Destroy the data when you leave this component
    //     localStorage.removeItem('kidSubmission');
    //     console.log("Data cleared from storage");
    // },
    beforeRouteLeave(to, from, next) {
        localStorage.removeItem('kidSubmission');
        next(); // Always call next() to allow the navigation to proceed
    },
    mounted() {
        
    },
    methods: {
        routeTo(route) {
            this.$router
            .push({
            path: `${route}`
            })
            .catch(() => {
            // console.log("none")
            });
        },
        goBack() {
            this.$router.go(-1);
        },
        async copyLink() {
            await navigator.clipboard.writeText(this.baseUrl);
            return this.$store.commit("setApiSuccess", "Link copied");
        },

        // This function is also in HomeSuperkid file take note
        getPriorityMedia(files) {
            // console.log("Files img", files)
            if (!files || !Array.isArray(files)) return null;
            // return files.find(file => file.media_type === 'image'); //uncomment later and comment out the next lines

            // const lastImage = [...files].reverse().find(file => file.media_type === 'image');
            // return lastImage ? lastImage.url : null;

            // const firstImage = files.find(f => f.media_type === 'image');
            // if (firstImage) return firstImage;  

            const lastImage = [...files].reverse().find(f => f.media_type === 'image');
            if (lastImage) return lastImage;

            // 2. If no image, find the first video
            const firstVideo = files.find(f => f.media_type === 'video');
            if (firstVideo) return firstVideo;

            return null;
            
        },
    },
    filters: {
        moment: function(date) {
        return moment(date).format("MMMM Do YYYY, h:mm:ss a");
        }
    }
};

</script>



<style scoped lang="scss">

.top-spot {
    margin-top: 30rem;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    h5 {
        cursor: pointer;
        font-family: Lato;
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        color: #4B4B4F;
        span {
            margin-right: 20px;
        }
    }
    button {
        background: #2EBFCA;
        color: #F5F7FA;
        font-family: Lato;
        font-weight: 600;
        font-size: 16px;
        border-radius: 50px;
    }
}

.display-body {
    margin-top: 45px;
}

.chalenge-item {
    background: #ffffff;
    border-radius: 20px;
    border: 1px solid #F5F7FA;
    padding: 12px;
    margin-bottom: 15px;
}

.kid-name-profile {
    display: flex;
    gap: 10px;
    text-align: left;
    align-items: center;
    margin-bottom: 30px;
    img {
        border-radius: 50px;
    }
    h5 {
        font-family: Lato;
        font-weight: 700;
        font-size: 16px;
        line-height: 16px;
        color: #1C2B3A;
        margin-bottom: 0;
    }
    p {
        margin-bottom: 0;
        color: #5D6F7C;
        font-family: Lato;
        font-weight: 800;
        font-size: 11px;
        line-height: 20px;

    }
}

.challenge-body {
    img {
    border-radius: 8px;
    max-height: 339px;
    height: 100%;
    object-fit: contain;
   }
   video {
        border-radius: 8px;
        // width: 600px;
        // max-height: 499px;
        max-height: 329px;
        height: 100%;
        object-fit: contain;
        width: 100%;
    }
    h3 {
        text-align: left;
        font-family: Nunito Sans;
        font-weight: 600;
        font-size: 18px;
        line-height: 24px;
        // color: #1C2B3A;
    }
    h4, h6 {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 26px;
        text-align: left;
    }
    h4 {
        color:  #5D6F7C;
    }
    h3 {
        color: #1C2B3A;
    }
    h6 {
        margin-top: 20px;
        color: #2EBFCA
    }
    .view-more {
        color: #2AB3E6;
        font-family: Lato;
        font-size: 20px;
        cursor: pointer;
        text-align: right;
    }
}

.vote-btn {
    margin-top: 40px;
    .vote-now {
        background: #2AB3E6;
        color: #ffffff;
        border-radius: 50px;
        min-height: 38px;
        font-family: Lato;
        font-weight: 600;
        font-size: 18px;
        width: 100%;
        outline: 0;
        box-shadow: none;
    }
    .copy-now {
        background: #CAECF9;
        color: #ffffff;
        border-radius: 50px;
        min-height: 38px;
        font-family: Lato;
        font-weight: 600;
        font-size: 18px;
        width: 100%;
        outline: 0;
        box-shadow: none;
    }
}
.vote-ends {
    font-family: Lato;
    font-size: 14px;
    text-align: left;
    color: #1A1A1A
}

.more-media {
    img {
        max-height: 600px;
        height: 100%;
        object-fit: contain;
    }
    video {
        // max-height: 600px;
        height: 100%;
        object-fit: contain;
    }
}
</style>